import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { DateTime } from 'luxon';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DashboardRangeService } from 'app/services/dashboard-team.service';
import { distinctUntilChanged, map, merge, shareReplay, Subject, tap } from 'rxjs';
import { SignalRService } from 'app/services/signal-r.service';


export enum DropDownRange {
  // LiveTrackingData = 'Live Tracking Data',
  ThisWeek = 'This Week',
  LastWeek = 'Last Week',
  Last7days = 'Last 7 days',
}

@Component({
  selector: 'tm-drop-down-range',
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatButtonModule, MatIconModule, MatRippleModule],
  templateUrl: './drop-down-range.component.html',
  styleUrls: ['./drop-down-range.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropDownRangeComponent {
  private readonly dashboardRangeService = inject(DashboardRangeService);
  // private readonly selectedRangeName$ = new Subject<string>();
  private readonly signalRService = inject(SignalRService);
  readonly isConnectedSignalR$ = this.signalRService.isConnected$;
  readonly itemsMenu = [DropDownRange.ThisWeek, DropDownRange.LastWeek, DropDownRange.Last7days];

  readonly rangeName$ = merge(
    // this.selectedRangeName$,
    this.dashboardRangeService.range$.pipe(
      map(range => range.name),
    )
  ).pipe(
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  selectRange(name: DropDownRange) {
    const currentDate = DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISO();
    switch (name) {
      case DropDownRange.ThisWeek: {
        const start = DateTime.fromISO(currentDate);
        this.dashboardRangeService.range$.next({ name, start: start.minus({ days: start.weekday - 1 }).toISO() });
        break;
      }
      case DropDownRange.LastWeek: {
        const start = DateTime.fromISO(currentDate);
        const newStart = start.minus({ days: 6 });
        this.dashboardRangeService.range$.next(
          {
            name,
            start: DateTime.fromISO(newStart.toISO()).minus({ days: newStart.weekday - 1 }).toISO(),
            end: DateTime.fromISO(newStart.toISO()).minus({ days: newStart.weekday - 1 }).plus({ days: 6 }).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).toISO()
          });
        break;
      }
      case DropDownRange.Last7days: {
        const start = DateTime.fromISO(currentDate);
        this.dashboardRangeService.range$.next({ name, start: start.minus({ days: 6 }).toISO() });
        break;
      }
    }
  }
}